import React from "react";

export default function SupportVideo() {
  return (
    <>
      <div className="h-full w-full">
        <div className="relative h-full w-full rounded-xl">
          <iframe
            src="https://player.vimeo.com/video/768675358?h=190226c1dd&amp;badge=0&amp;autopause=0&amp;loop=1&amp;quality=1080p&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay;"
            autoPlay="1"
            title="SummerEyes Product Overview Video"
            className=" h-full w-full rounded-xl object-scale-down"
          ></iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
      </div>
    </>
  );
}
